<div id="headersection">
  <div class="overlay" [class.open]="mobileMenuOpen">
    <button matIconButton type="button" class="close-button" (click)="closeNav()">&times;</button>

    <nav class="overlay-nav">
      <a data-id="landing-page" matButton [routerLink]="['/landing']" (click)="closeNav()" routerLinkActive="active-link">
        @if (!simple) {
          <span>Trade</span>
        }
        @if (simple) {
          <span>Prices</span>
        }
      </a>

      @if ($loggedIn | async) {
        <a
          data-id="transactions=page"
          matButton
          (click)="closeNav()"
          [routerLink]="['/transaction-history']"
          routerLinkActive="active-link"
        >
          Transactions
        </a>
        <a data-id="portfolio-page" matButton (click)="closeNav()" [routerLink]="['/portfolio']" routerLinkActive="active-link"
          >Portfolio</a
        >
        <a data-id="settings-page" matButton (click)="closeNav()" [routerLink]="['/settings']" routerLinkActive="active-link">Settings</a>
        <button data-id="logout" type="button" matButton (click)="logout(); closeNav()">Log Out</button>
      } @else {
        <a data-id="sign-up-page" matButton (click)="closeNav()" [routerLink]="['signup']" routerLinkActive="active-link">Sign Up</a>
        <a data-id="sign-in-page" matButton (click)="closeNav()" [routerLink]="['login']" routerLinkActive="active">Log In</a>
      }
    </nav>
  </div>

  @if (platform === Platform.IOS) {
    <mat-toolbar class="mobile-header app-store-toolbar">
      <span class="mobile-header-text">CoinZoom</span>
      <span class="toolbar-spacer"></span>
      <a href="https://apps.apple.com/us/app/coinzoom-buy-bitcoin-crypto/id1575983875?mt=8" class="ios-store-link"></a>
    </mat-toolbar>
  }
  @if (platform === Platform.Android) {
    <mat-toolbar class="mobile-header app-store-toolbar">
      <span class="mobile-header-text">CoinZoom</span>
      <span class="toolbar-spacer"></span>
      <a matButton href="https://play.google.com/store/apps/details?id=com.coinzoom.android" class="android-link">Open</a>
    </mat-toolbar>
  }

  <mat-toolbar class="mobile-header mobile-main-toolbar">
    <button matIconButton type="button" (click)="openNav()">
      <svg viewBox="0 0 512 512">
        <path
          d="M491.318,235.318H20.682C9.26,235.318,0,244.577,0,256s9.26,20.682,20.682,20.682h470.636
           c11.423,0,20.682-9.259,20.682-20.682C512,244.578,502.741,235.318,491.318,235.318z"
        />

        <path
          d="M491.318,78.439H20.682C9.26,78.439,0,87.699,0,99.121c0,11.422,9.26,20.682,20.682,20.682h470.636
           c11.423,0,20.682-9.26,20.682-20.682C512,87.699,502.741,78.439,491.318,78.439z"
        />

        <path
          d="M491.318,392.197H20.682C9.26,392.197,0,401.456,0,412.879s9.26,20.682,20.682,20.682h470.636
           c11.423,0,20.682-9.259,20.682-20.682S502.741,392.197,491.318,392.197z"
        />
      </svg>
    </button>
    <span class="toolbar-spacer"></span>
    <a [routerLink]="['/']">
      <img itemprop="image" class="logo logo-dark mt-x1" alt="CoinZoom Exchange" src="./assets/image/icons/logo_white.svg" width="140" />
    </a>
    <span class="toolbar-spacer"></span>
  </mat-toolbar>

  <mat-toolbar class="header-toolbar">
    <a data-id="home-page" class="brand-link" [routerLink]="['/']">
      <img itemprop="image" class="logo logo-dark mt-x1" alt="CoinZoom Exchange" src="./assets/image/icons/logo_white.svg" width="140" />
    </a>

    <span class="toolbar-spacer"></span>

    <nav class="primary-nav">
      <a data-id="landing-page" matButton [routerLink]="['/landing']" routerLinkActive="active-link">
        @if (!simple) {
          <span>Trade</span>
        }
        @if (simple) {
          <span>Prices</span>
        }
      </a>

      @if ($loggedIn | async) {
        @if (authService.seeEarn) {
          <a
            data-id="transactions-page"
            matButton
            [routerLink]="['/portfolio/earn']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Earn
          </a>
        }
        @if (authService.seeMarginTrading) {
          <a
            data-id="transactions-page"
            matButton
            [routerLink]="['/portfolio/margin']"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Margin
          </a>
        }
        <a data-id="portfolio-page" matButton [routerLink]="['/portfolio']" [class.active-link]="portfolioActive"> Portfolio </a>
        <a data-id="transactions-page" matButton [routerLink]="['/transaction-history']" routerLinkActive="active-link"> Transactions </a>
        <a data-id="settings-page" matButton [routerLink]="['/settings']" routerLinkActive="active-link"> Settings </a>
        <button data-id="logout" type="button" matButton (click)="logout()">Log Out</button>
      } @else {
        <a data-id="sign-up-page" matButton [routerLink]="['signup']" routerLinkActive="active-link">Sign Up</a>
        <a data-id="sign-in-page" matButton [routerLink]="['login']" routerLinkActive="active-link">Log In</a>
      }
    </nav>

    <div class="header-actions">
      @if (themeable) {
        <mat-divider vertical></mat-divider>
        <button matIconButton type="button" title="Change Theme" (click)="toggleTheme()">
          @if (theme === Theme.day) {
            <mat-icon>dark_mode</mat-icon>
          }
          @if (theme === Theme.night) {
            <mat-icon>light_mode</mat-icon>
          }
        </button>
      }

      <mat-divider vertical></mat-divider>
      <button matIconButton type="button" title="Show Messages" (click)="showMessages = !showMessages">
        @if (showMessages) {
          <mat-icon>drafts</mat-icon>
        } @else {
          <mat-icon>mail</mat-icon>
        }
        @if (hasUnreadMessages) {
          <span class="unread-messages-badge"></span>
        }
      </button>
    </div>
  </mat-toolbar>

  @if (showMessages) {
    <app-messages></app-messages>
  }
</div>
